module.exports = __webpack_public_path__ + "static/img/perform-blsx.1a5ff452.png";